import React from 'react';

export const WarningIcon = ({ fill }) => {
  return (
    <svg width='16' height='16' viewBox='0 0 16 16' fill={fill} xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M8 0.125C3.65117 0.125 0.125 3.65117 0.125 8C0.125 12.3488 3.65117 15.875 8 15.875C12.3488 15.875 15.875 12.3488 15.875 8C15.875 3.65117 12.3488 0.125 8 0.125ZM7.4375 4.20312C7.4375 4.12578 7.50078 4.0625 7.57812 4.0625H8.42188C8.49922 4.0625 8.5625 4.12578 8.5625 4.20312V8.98438C8.5625 9.06172 8.49922 9.125 8.42188 9.125H7.57812C7.50078 9.125 7.4375 9.06172 7.4375 8.98438V4.20312ZM8 11.9375C7.77921 11.933 7.56898 11.8421 7.41442 11.6844C7.25986 11.5266 7.1733 11.3146 7.1733 11.0938C7.1733 10.8729 7.25986 10.6609 7.41442 10.5031C7.56898 10.3454 7.77921 10.2545 8 10.25C8.22079 10.2545 8.43103 10.3454 8.58558 10.5031C8.74014 10.6609 8.8267 10.8729 8.8267 11.0938C8.8267 11.3146 8.74014 11.5266 8.58558 11.6844C8.43103 11.8421 8.22079 11.933 8 11.9375Z'
        fill={fill}
      />
    </svg>
  );
};
